(function(){
  'use strict';

  function initAxcelerateSignin(configuration) {
    const pageQueryStringArray = window.location.href.split('?');
    const userContactIdLocal = localStorage.getItem('userContactId');
    const userContactExpiryLocal = localStorage.getItem('userContactExpiry') || 0;
    const userButtonLocal = JSON.parse( localStorage.getItem('userButton') );
    let modifiedPageUrl = '';
    let xhrDataRequest = new XMLHttpRequest(); // We use this to make our asynchronous requests for data

    // Page hooks and event listeners
    const alertMessagePopup = document.getElementsByClassName(configuration.alertMessagePopupClass)[0];
    const alertMessage = document.getElementsByClassName(configuration.alertMessageContainerClass)[0];
    const alertDetails = document.getElementsByClassName(configuration.alertDetailsContainerClass)[0];
    const alertMessagePopupCloseButton = document.getElementsByClassName(configuration.alertMessageCloseButtonClass)[0];
    const loadingMessage = document.getElementsByClassName(configuration.loadingMessageContainerClass)[0];
    const userNameField = document.getElementsByClassName(configuration.userNameContainerClass)[0];
    const continueButton = document.getElementsByClassName(configuration.continueButtonClass)[0];
    const placeholderButton = document.getElementsByClassName(configuration.placholderButtonClass)[0];
    const redirectButton = document.getElementsByClassName(configuration.redirectButtonClass)[0];
    const signOutLink = document.getElementsByClassName(configuration.signOutLinkClass)[0];

    alertMessagePopupCloseButton.addEventListener('click', onAlertCloseClick);

    signOutLink.addEventListener('click', onSignOutClick);

    // Check if the user already has an aXcelerate contact ID in the local storage
    if (userContactIdLocal !== null && userButtonLocal !== null) {
      /**
       * The user already has an active session.
       */

      // Check if we should reset their contact ID
      if ( userContactIdHasExpired(userContactExpiryLocal) ) {
        // The contact ID should be reset

        // Clear the local storage data
        localStorage.removeItem('userContactId');
        localStorage.removeItem('userButton');
        localStorage.removeItem('userContactExpiry');

        // Show the login option
        toggleButtonDisplay('login');
      } else {
        // Contact ID is still valid

        // Add their name to the button
        populateButton();

        // Show continue button
        toggleButtonDisplay('continue');
      }

    } else if (userContactIdLocal !== null) {
      /**
       * We know the user's contact ID, but not their details
       */

      // Retrieve any additional information about this user
      getAxcelerateUserDetails(userContactIdLocal)
        .then( (data) => {
          // Check the response data
          if (!data.ERROR) {

            // Capture the user's details into local storage
             localStorage.setItem('userButton',
               JSON.stringify({
                 "fname": data.GIVENNAME, // First name
                 "lname": data.SURNAME // Last name
               })
             );

              // Add their name to the button
              populateButton();

              // Show continue button
              toggleButtonDisplay('continue');
          } else {
            // Notify the user that if were unable to retrieve their details
            setAlertMessage('There has been an error verifying your aXcelerate account. Please try again or continue with a different account.', `Message: ${data.DETAILS}`);

            // Show the login option
            toggleButtonDisplay('login');
          }

          // Hide the loading message
          toggleLoadingMessage(false);
        })
        .catch( (errorObject) => {
          if (errorObject.eventType === 'error') {
                // Notify the user that if were unable to retrieve their details
                setAlertMessage('There has been an error verifying your aXcelerate account. Please try again or continue with a different account.', `Status code: ${errorObject.response.status}`);
              }

          // Hide the loading message
          toggleLoadingMessage(false);

          // Show the login option
          toggleButtonDisplay('login');
        });
    } else {
      /**
       * This is a new user session as there is no contact ID
       * stored in the browser local storage.
       *
       * One of two things is happening here:
       * 1. Either this is a new user visiting the page
       *    for the first time (or a new session); OR,
       * 2. This is a user that has completed the aXcelerate
       *    login and has just been redirected back to this page
       *
       * For #1, we show the login button.
       *
       * For #2, there will be a "access_code" query parameter
       * and Matrix will automatically print a hidden Custom Form
       * into the page that we need to submit with JavaScript.
       * See Matrix Asset: #22428
       *
       * It's setup this way because we need to process the response
       * from the form's Submission Action in Matrix so that we can
       * encrypt the user's contact ID before storing it in the browser.
       */

      // Check for the hidden Matrix Form.
      const accessCodeForm = document.getElementsByClassName(configuration.accessCodeFormContainerClass);

      if (accessCodeForm.length !== 0) {
        // Initialise the AJAX loader for the access code form
        const accessCodeAjaxFormConfig = {
          formElement: accessCodeForm[0],
          onLoadCallback: (xhrEvent) => { onAccessCodeSubmissionComplete(xhrEvent); }
        };

        // Update the page URL to remove the "access_code" query parameter
        if (pageQueryStringArray.length > 0) {
          // eslint-disable-next-line no-undef
          modifiedPageUrl = squiz.fn.removeQueryParameterValuesByKey(pageQueryStringArray[1], 'access_code');
          window.history.replaceState(null, document.title, pageQueryStringArray[0] + '?' + modifiedPageUrl);
        }

        // eslint-disable-next-line no-undef
        squiz.fn.initFormSubmissionHandler(accessCodeAjaxFormConfig);

        // Show the loading message
        toggleLoadingMessage(true);

        // Automatically submit the access code form
        accessCodeForm[0].querySelector('input[type=submit]').click();
      } else {
        // No stored sign-in or redirect, just show the login button
        toggleButtonDisplay('login');
      }
    }

    /**
     * Add the user's name to the training platform button
     *
     * @returns void
     */
    function populateButton() {
      const userButtonLocal = JSON.parse( localStorage.getItem('userButton') );
      userNameField.textContent = `${userButtonLocal.fname} ${userButtonLocal.lname}`;
    }

    /**
     * Display a specific button and hide the others
     *
     * @param {String} buttonType The "type" of button to display. Options are: 'login' or 'continue'
     *
     * @returns void
     */
    function toggleButtonDisplay(buttonType) {

      if (buttonType === 'login') {
        placeholderButton.classList.add('is-hidden');
        redirectButton.classList.remove('is-hidden');
      }

      if (buttonType === 'continue') {
        placeholderButton.classList.add('is-hidden');
        continueButton.classList.remove('is-hidden');
      }
    }

    /**
     * Actions to take once the new login Access Code form has been submitted
     *
     * @param {XHR Event} xhrEvent The loadend event of the XHR request that submitted the form
     *
     * @returns void
     */
    function onAccessCodeSubmissionComplete(xhrEvent) {
      let responseContent = null;

      try {
        // Matrix may give us JSON or HTML
        responseContent = JSON.parse(xhrEvent.currentTarget.response);
      } catch {
        // Do nothing. Likely this is just the form being returned with validation errors
        return;
      }

      if (!responseContent.ERROR) {
          // User verified successfully.

          // Store the encrypted contact ID in local storage
          localStorage.setItem('userContactId', responseContent.CONTACTID);

          // Set the expiry time (2 hours) for the user's contact ID
          localStorage.setItem('userContactExpiry', Date.now() + 7200000);

          // Retrieve any additional information about this user
          getAxcelerateUserDetails(responseContent.CONTACTID)
            .then( (data) => {
              // Check the response data
              if (!data.ERROR) {

                // Capture the user's details into local storage
                 localStorage.setItem('userButton',
                   JSON.stringify({
                     "fname": data.GIVENNAME, // First name
                     "lname": data.SURNAME // Last name
                   })
                 );

                  // Add their name to the button
                  populateButton();

                  // Show continue button
                  toggleButtonDisplay('continue');
              } else {
                // Notify the user that if were unable to retrieve their details
                setAlertMessage('There has been an error verifying your aXcelerate account. Please try again or continue with a different account.', `Message: ${data.DETAILS}`);

                // Show the login option
                toggleButtonDisplay('login');
              }

              // Hide the loading message
              toggleLoadingMessage(false);
            })
            .catch( (errorObject) => {
              if (errorObject.eventType === 'error') {
                // Notify the user that if were unable to retrieve their details
                setAlertMessage('There has been an error verifying your aXcelerate account. Please try again or continue with a different account.', `Status code: ${errorObject.response.status}`);
              }

              // Hide the loading message
              toggleLoadingMessage(false);

              // Show the login option
              toggleButtonDisplay('login');
            });
      } else {
        // Verification was unsuccessful. Show error message
        setAlertMessage('There has been an error verifying your aXcelerate account. Please try again or continue with a different account.', `Message: ${responseContent.DETAILS}`);

        // Hide the loading message
        toggleLoadingMessage(false);

        // Show the login option
        toggleButtonDisplay('login');
      }
    }

    /**
     * Contact Matrix to retrieve any additional details for
     * the provided aXcelerate user ID
     *
     * @param {String} contactId The encrypted ID of the user to lookup
     *
     * @returns Promise
     */
    function getAxcelerateUserDetails(contactId) {
      let url = "";
      let requestPromise = null;

      // Abort any current request
      xhrDataRequest.abort();

      // Generate a new request (this clears any current listeners)
      xhrDataRequest = new XMLHttpRequest();

      // Create our new Promise
      requestPromise = newRequestPromise(xhrDataRequest);

      // Assemble the request URL
      url = `${configuration.axcelerateUserDetailsLookupEndpoint}?contactid=${contactId}&cors_key=${configuration.corsKey}`;

      // Set up our request
      xhrDataRequest.open("GET", url);

      // Make the request
      xhrDataRequest.send();

      return requestPromise;
    }

    /**
     * Display either the alert (information) or error (critical issue)
     * popup with a message as feedback for the user
     *
     * @param {String} msg The general message to display
     * @param {String} details An additional message with specific information
     *
     * @returns void
     */
    function setAlertMessage(msg, details) {
      // Set the alert content
      alertMessage.textContent = msg;

      if (details !== '') {
        alertDetails.textContent = details;
      }

      // Show the alert popup
      alertMessagePopup.classList.add('is-active');
    }

    /**
     * Hide the alert popup
     *
     * @param {Click Event} evt Click Event on the button
     *
     * @returns void
     */
    function onAlertCloseClick(evt) {
      evt.preventDefault();

      // Hide the alert popup
      alertMessagePopup.classList.remove('is-active');
    }

    /**
     * Respond to clicks on the sign out link
     *
     * @returns void
     */
    function onSignOutClick() {
      // Clear the local storage data
      localStorage.removeItem('userContactId');
      localStorage.removeItem('userButton');
      localStorage.removeItem('userContactExpiry');
    }

    /**
     * Show or hide the loading message as feedback for the user
     *
     * @param {Boolean} show Whether or not the message should be visible
     *
     * @returns void
     */
    function toggleLoadingMessage(show) {
      if (show) {
        loadingMessage.classList.add('is-active');
      } else {
        loadingMessage.classList.remove('is-active');
      }
    }

    /**
     * Compare a provided time to UTC current time.
     * The provided time has "expired" if it is in the past.
     *
     * @param {Number} expiryTime Description
     *
     * @returns Boolean
     */
    function userContactIdHasExpired(expiryTime) {
      const currentUTCTime = Date.now();
      const expiryUTCTime = expiryTime;
      let hasExpired = false;

      // console.log('Current', currentUTCTime)
      // console.log('Expiry', expiryUTCTime)

      if (currentUTCTime >= expiryUTCTime) {
        hasExpired = true;
      }

      return hasExpired;
    }
  }

  /**
   * Create a new Promise that we can use to response to asynchronus XML Http Requests
   *
   * @param {XMLHttpRequest} xhrRequest The XMLHttpRequest to attach the event listeners to
   * @param {String} responseType The expected content type of the response. Default: JSON
   *
   * @returns Promise
   */
  function newRequestPromise(xhrRequest, responseType) {
    return new Promise( (resolve, reject) => {
      // Respond to requests to GET the data
      xhrRequest.addEventListener('load', function(evt) {
        if (evt.currentTarget.status === 200) {
          // We got a good response
          if (responseType === 'html') {
            resolve(evt.currentTarget.response);
          } else {
            resolve(JSON.parse(evt.currentTarget.response));
          }
        } else {
          // We got a bad response (e.g. 403, 404)
          reject( {
            "response": evt.currentTarget,
            "eventType": 'error'
            }
          );
        }
      });

      // Respond to request errors
      xhrRequest.addEventListener('error', function(evt) {
        reject( {
          "response": evt.currentTarget,
          "eventType": 'error'
          }
        );
      });

      // Respond to request aborts
      xhrRequest.addEventListener('abort', function(evt) {
        reject( {
          "response": evt.currentTarget,
          "eventType": 'abort'
          }
        );
      });
    });
  }

  // eslint-disable-next-line no-undef
  const axcelerateSigninConfiguration = (typeof axcelerateSigninConfig !== 'undefined') ? axcelerateSigninConfig : null;

  // Initialise the signin process
  if (axcelerateSigninConfiguration !== null) {
    initAxcelerateSignin(axcelerateSigninConfiguration);
  }
}());
